document.addEventListener('click', function (e) {
  const faqItem = e.target.closest('.faq-contant');
  if (!faqItem) return;

  const section = faqItem.closest('.custom-faq-parent');
  if (!section) return;

  const answer = faqItem.querySelector('.faq-contant-answer');
  const icon   = faqItem.querySelector('.faq-contant-icon');

  section.querySelectorAll('.faq-contant-answer.open').forEach(openAnswer => {
    if (openAnswer !== answer) {
      openAnswer.classList.remove('open');
      openAnswer.style.maxHeight = null;
      openAnswer.style.opacity = '0';

      const parentItem = openAnswer.closest('.faq-contant');
      parentItem.classList.remove('open');

      const otherIcon = parentItem.querySelector('.faq-contant-icon');
      if (otherIcon) {
        otherIcon.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="black"/>
</svg>`;
      }
    }
  });

  // Toggle current FAQ
  if (answer.classList.contains('open')) {
    answer.classList.remove('open');
    answer.style.maxHeight = null;
    answer.style.opacity = '0';
    faqItem.classList.remove('open');

    icon.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="black"/>
</svg>`;
  } else {
    answer.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.opacity = '1';
    faqItem.classList.add('open');

    icon.innerHTML = `
      <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 0H0V2H14V0Z" fill="black"/>
      </svg>
    `;
  }
});